<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="addlinks-dialog"
  >
    <feishu-form
    ref="form"
    :form-data="formData"
    :editing="true"
    @submit="submitHandle"
  ></feishu-form>
    </sliderBarDialogShell>
</template>

<script>
import { buildFeishuConfigPayload, editFeishuConfig } from '@/api/sys/robitConfig/feishu'
import feishuForm from '@/components/sys/robitCofig/feishu/feishuForm'

export default {
  name: 'editfeishu',
  components:{
    feishuForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
    }
  },
  data() {
    return {
      title: '编辑飞书推送渠道'
    }
  },
  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$refs.form.clearSignSecret();
      this.$emit('close');
    },

    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
        const request = editFeishuConfig(buildFeishuConfigPayload(formData, true));
        this.$refs.form.clearSignSecret();
        request.then(() => {
            this.$refs.form.$refs.form.clearValidate();
            this.$refs.form.$refs.form.resetFields();
            this.$emit('edit-success');
            this.$refs.form.reset();
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
